export default "__VITE_ASSET__3k4Eb8OJ__"